import React, { useState, useEffect } from 'react';
import { notification } from '../../component/hocs/notification';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import axios from 'axios';
import { mainurl } from '../../Mainurl';
import * as XLSX from 'xlsx/xlsx.mjs';

import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Form,
    Input,
    InputGroup,
    InputGroupText,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Badge,
    Spinner,
    Alert
} from 'reactstrap';
import {
    FaEye,
    FaSearch,
    FaDownload,
    FaBell,
    FaExclamationTriangle,
    FaCalendarAlt,
    FaPaw,
    FaUser,
    FaClipboardList,
    FaStethoscope,
    FaClock,
    FaUsers
} from 'react-icons/fa';

const LivestockAlert = () => {
    const [mode, setMode] = useState("1");
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [downloadLoading, setDownloadLoading] = useState(false);

    const [viewModal, setViewModal] = useState(false);
    const [modalData, setModalData] = useState('');

    const get_livestock_Alert = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "user_id": sessionStorage.getItem('user_id'),
                "lang_id": 1
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Activity/animal_alert',
                data: postData,
                headers: { 'Content-Type': 'application/JSON', }
            });

            let list = response.data.map((row, index) => {
                const futureDate = new Date(row.future_activity_date);
                const today = new Date();
                const diffTime = futureDate - today;
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                return {
                    sl: index + 1,
                    farmer_id: row.farmer_id,
                    activity_desc: row.activity_desc,
                    animal_type_name: row.animal_type_name,
                    future_activity_date: row.future_activity_date.split(" ")[0].split('-').reverse().join('-'),
                    days_remaining: diffDays,
                    urgency: diffDays <= 0 ? 'overdue' : diffDays <= 3 ? 'urgent' : diffDays <= 7 ? 'soon' : 'normal',
                    action: (
                        <Button
                            color="info"
                            size="sm"
                            outline
                            className="d-flex align-items-center gap-1"
                            onClick={() => viewDetailsHandler(row)}
                        >
                            <FaEye size={14} />
                            View
                        </Button>
                    ),
                    rawData: row
                };
            });

            // Sort by urgency (overdue first, then urgent, etc.)
            list.sort((a, b) => {
                const urgencyOrder = { 'overdue': 0, 'urgent': 1, 'soon': 2, 'normal': 3 };
                return urgencyOrder[a.urgency] - urgencyOrder[b.urgency];
            });

            setTableData(list);
            setFilteredData(list);

            let notify = notification({
                message: `${list.length} livestock alerts loaded successfully`,
                type: 'success'
            });
            notify();
        } catch (error) {
            let notify = notification({
                message: "Failed to load livestock alerts. Please try again.",
                type: 'error'
            });
            notify();
        } finally {
            setLoading(false);
        }
    };

    const viewDetailsHandler = (data) => {
        setModalData(data);
        setViewModal(true);
    };

    const download_excel_handler = async () => {
        setDownloadLoading(true);

        try {
            if (tableData.length === 0) {
                let notify = notification({
                    message: "No data available for download",
                    type: 'warning'
                });
                notify();
                return;
            }

            let list = tableData.map((row, index) => {
                return {
                    sl_no: index + 1,
                    farmer_id: row.farmer_id,
                    animal_type: row.animal_type_name,
                    activity_description: row.activity_desc,
                    scheduled_date: row.future_activity_date,
                    days_remaining: row.days_remaining,
                    urgency_level: row.urgency
                };
            });

            let wb = XLSX.utils.book_new(),
                ws = XLSX.utils.json_to_sheet(list);
            XLSX.utils.book_append_sheet(wb, ws, "Livestock_Alerts_Report");
            XLSX.writeFile(wb, `livestock_alerts_report_${new Date().toISOString().split('T')[0]}.xlsx`);

            let notify = notification({
                message: "Excel report downloaded successfully!",
                type: 'success'
            });
            notify();
        } catch (error) {
            let notify = notification({
                message: "Download failed. Please try again.",
                type: 'error'
            });
            notify();
        } finally {
            setDownloadLoading(false);
        }
    };

    // Search functionality
    const handleSearch = (value) => {
        setSearchTerm(value);
        if (value === '') {
            setFilteredData(tableData);
        } else {
            const filtered = tableData.filter(item =>
                item.farmer_id.toLowerCase().includes(value.toLowerCase()) ||
                item.activity_desc.toLowerCase().includes(value.toLowerCase()) ||
                item.animal_type_name.toLowerCase().includes(value.toLowerCase()) ||
                item.future_activity_date.includes(value)
            );
            setFilteredData(filtered);
        }
    };

    // Calculate statistics
    const totalAlerts = tableData.length;
    const overdueAlerts = tableData.filter(item => item.urgency === 'overdue').length;
    const urgentAlerts = tableData.filter(item => item.urgency === 'urgent').length;
    const upcomingAlerts = tableData.filter(item => item.urgency === 'soon').length;

    const getUrgencyBadge = (urgency, daysRemaining) => {
        switch (urgency) {
            case 'overdue':
                return <Badge color="danger" pill><FaExclamationTriangle size={10} className="me-1" />Overdue</Badge>;
            case 'urgent':
                return <Badge color="warning" pill><FaClock size={10} className="me-1" />{daysRemaining} days</Badge>;
            case 'soon':
                return <Badge color="info" pill><FaClock size={10} className="me-1" />{daysRemaining} days</Badge>;
            default:
                return <Badge color="success" pill><FaClock size={10} className="me-1" />{daysRemaining} days</Badge>;
        }
    };

    const columns = [
        {
            name: '#',
            selector: row => row.sl,
            sortable: true,
            width: '70px',
            center: true
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaUser size={12} />
                    Farmer ID
                </div>
            ),
            selector: row => row.farmer_id,
            sortable: true,
            width: '120px',
            cell: row => (
                <Badge color="light" className="text-primary" pill>
                    {row.farmer_id}
                </Badge>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaPaw size={12} />
                    Animal Type
                </div>
            ),
            selector: row => row.animal_type_name,
            sortable: true,
            width: '150px',
            cell: row => (
                <Badge 
                    color={
                        row.animal_type_name?.toLowerCase().includes('cow') || 
                        row.animal_type_name?.toLowerCase().includes('cattle') ? 'success' :
                        row.animal_type_name?.toLowerCase().includes('goat') ? 'warning' :
                        row.animal_type_name?.toLowerCase().includes('chicken') || 
                        row.animal_type_name?.toLowerCase().includes('poultry') ? 'info' :
                        'secondary'
                    }
                    className="text-white"
                >
                    {row.animal_type_name}
                </Badge>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaStethoscope size={12} />
                    Activity
                </div>
            ),
            selector: row => row.activity_desc,
            sortable: true,
            width: '250px',
            cell: row => (
                <div className="text-truncate" title={row.activity_desc}>
                    <Badge 
                        color={
                            row.activity_desc?.toLowerCase().includes('vaccination') ? 'success' :
                            row.activity_desc?.toLowerCase().includes('treatment') ? 'warning' :
                            row.activity_desc?.toLowerCase().includes('checkup') ? 'info' :
                            'secondary'
                        }
                        className="text-white"
                    >
                        {row.activity_desc}
                    </Badge>
                </div>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaCalendarAlt size={12} />
                    Scheduled Date
                </div>
            ),
            selector: row => row.future_activity_date,
            sortable: true,
            width: '150px',
            cell: row => (
                <Badge color="secondary" outline>
                    {row.future_activity_date}
                </Badge>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaBell size={12} />
                    Status
                </div>
            ),
            selector: row => row.urgency,
            sortable: true,
            center: true,
            width: '130px',
            cell: row => getUrgencyBadge(row.urgency, row.days_remaining)
        },
        {
            name: 'Actions',
            selector: row => row.action,
            sortable: false,
            center: true,
            width: '120px'
        }
    ];

    return (
        <>
            <Header />
            <Page title='Livestock Alert Management' breadcrumbs='Home / Livestock Alert'>
                <Row className='p-3'>
                    {mode === "1" && (
                        <Col xs={12}>
                            {/* Action Bar */}
                            <Card className='mb-4 border-0 shadow-sm'>
                                <CardBody className="py-3">
                                    <Row className="align-items-center">
                                        <Col md={8}>
                                            <div className="d-flex gap-2">
                                                <Button
                                                    color='primary'
                                                    size="sm"
                                                    onClick={get_livestock_Alert}
                                                    disabled={loading}
                                                    className="d-flex align-items-center gap-2"
                                                >
                                                    {loading ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <FaBell size={14} />
                                                    )}
                                                    {loading ? 'Loading...' : 'Load Alerts'}
                                                </Button>
                                                <Button
                                                    color='secondary'
                                                    size="sm"
                                                    onClick={download_excel_handler}
                                                    disabled={downloadLoading || tableData.length === 0}
                                                    className="d-flex align-items-center gap-2 text-white"
                                                >
                                                    {downloadLoading ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <FaDownload size={14} />
                                                    )}
                                                    {downloadLoading ? 'Downloading...' : 'Download Excel'}
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <InputGroup size="sm">
                                                <InputGroupText className="bg-light border-end-0">
                                                    <FaSearch className="text-muted" />
                                                </InputGroupText>
                                                <Input
                                                    type="search"
                                                    placeholder='Search alerts, farmers, activities...'
                                                    value={searchTerm}
                                                    onChange={(e) => handleSearch(e.target.value)}
                                                    className="border-start-0"
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            {/* Alert Statistics Cards */}
                            {tableData.length > 0 && (
                                <Row className="mb-4">
                                    <Col md={3}>
                                        <Card className="border-0 bg-danger text-white">
                                            <CardBody className="text-center py-3">
                                                <FaExclamationTriangle size={24} className="mb-2" />
                                                <h5 className="mb-0">{overdueAlerts}</h5>
                                                <small>Overdue Alerts</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-warning text-white">
                                            <CardBody className="text-center py-3">
                                                <FaClock size={24} className="mb-2" />
                                                <h5 className="mb-0">{urgentAlerts}</h5>
                                                <small>Urgent (≤3 days)</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-info text-white">
                                            <CardBody className="text-center py-3">
                                                <FaBell size={24} className="mb-2" />
                                                <h5 className="mb-0">{upcomingAlerts}</h5>
                                                <small>Upcoming (≤7 days)</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-primary text-white">
                                            <CardBody className="text-center py-3">
                                                <FaClipboardList size={24} className="mb-2" />
                                                <h5 className="mb-0">{totalAlerts}</h5>
                                                <small>Total Alerts</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            )}

                            {/* Critical Alerts Banner */}
                            {overdueAlerts > 0 && (
                                <Alert color="danger" className="mb-4 d-flex align-items-center">
                                    <FaExclamationTriangle size={20} className="me-2" />
                                    <div>
                                        <strong>Critical Alert!</strong> You have {overdueAlerts} overdue livestock activities that require immediate attention.
                                    </div>
                                </Alert>
                            )}

                            {/* Main Data Table */}
                            <Card className='border-0 shadow-sm'>
                                <CardHeader className="bg-white border-bottom">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h5 className="mb-0">Livestock Alert Dashboard</h5>
                                            <small className='text-muted'>
                                                {filteredData.length > 0 ?
                                                    `Showing ${filteredData.length} of ${tableData.length} alerts` :
                                                    'No alerts found'
                                                }
                                            </small>
                                        </div>
                                        {searchTerm && (
                                            <Badge color="secondary" className="ms-2">
                                                Filtered: {filteredData.length}
                                            </Badge>
                                        )}
                                    </div>
                                </CardHeader>
                                <CardBody className="p-0">
                                    {tableData.length === 0 && !loading ? (
                                        <Alert color="info" className="m-3 text-center">
                                            <FaBell size={48} className="mb-3 text-muted" />
                                            <p className="mb-2">No livestock alerts loaded yet</p>
                                            <small>Click "Load Alerts" to fetch the latest alert data</small>
                                        </Alert>
                                    ) : (
                                        <DataTable
                                            title=""
                                            customStyles={custTableStyles}
                                            columns={columns}
                                            data={filteredData}
                                            highlightOnHover
                                            responsive
                                            pagination
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                            progressPending={loading}
                                            progressComponent={
                                                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                                    <Spinner color="primary" />
                                                    <p className="mt-2 text-muted">Loading alerts...</p>
                                                </div>
                                            }
                                            noDataComponent={
                                                <div className="text-center py-5">
                                                    <FaSearch size={48} className="text-muted mb-3" />
                                                    <p className="text-muted">No alerts match your search criteria</p>
                                                </div>
                                            }
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    )}
                </Row>
            </Page>

            {/* Enhanced Modal for Alert Details */}
            <Modal
                centered
                size="lg"
                isOpen={viewModal}
                toggle={() => setViewModal(!viewModal)}
            >
                <ModalHeader
                    toggle={() => setViewModal(!viewModal)}
                    className="bg-light border-bottom"
                >
                    <div className="d-flex align-items-center gap-2">
                        <FaBell className="text-primary" />
                        <div>
                            <h5 className="mb-0">Livestock Alert Details</h5>
                            <small className="text-muted">
                                Scheduled activity information
                            </small>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {modalData && (
                        <div className="row g-3">
                            <div className="col-12">
                                <Card className="border-0 bg-light">
                                    <CardBody>
                                        <Row>
                                            <Col md={6} className="mb-3">
                                                <label className="form-label text-muted small fw-bold">Farmer Information</label>
                                                <div className="p-3 bg-white rounded border">
                                                    <div className="text-center">
                                                        <FaUser size={32} className="text-primary mb-2" />
                                                        <div>
                                                            <Badge color="primary" pill className="fs-6">
                                                                {modalData.farmer_id}
                                                            </Badge>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={6} className="mb-3">
                                                <label className="form-label text-muted small fw-bold">Animal Information</label>
                                                <div className="p-3 bg-white rounded border">
                                                    <div className="text-center">
                                                        <FaPaw size={32} className="text-success mb-2" />
                                                        <div>
                                                            <Badge 
                                                                color={
                                                                    modalData.animal_type_name?.toLowerCase().includes('cow') || 
                                                                    modalData.animal_type_name?.toLowerCase().includes('cattle') ? 'success' :
                                                                    modalData.animal_type_name?.toLowerCase().includes('goat') ? 'warning' :
                                                                    modalData.animal_type_name?.toLowerCase().includes('chicken') || 
                                                                    modalData.animal_type_name?.toLowerCase().includes('poultry') ? 'info' :
                                                                    'secondary'
                                                                }
                                                                className="text-white fs-6"
                                                            >
                                                                {modalData.animal_type_name}
                                                            </Badge>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={12} className="mb-3">
                                                <label className="form-label text-muted small fw-bold">Scheduled Activity</label>
                                                <div className="p-3 bg-white rounded border">
                                                    <div className="mb-2">
                                                        <small className="text-muted">Activity Description</small>
                                                        <div className="fw-bold">
                                                            <Badge 
                                                                color={
                                                                    modalData.activity_desc?.toLowerCase().includes('vaccination') ? 'success' :
                                                                    modalData.activity_desc?.toLowerCase().includes('treatment') ? 'warning' :
                                                                    modalData.activity_desc?.toLowerCase().includes('checkup') ? 'info' :
                                                                    'secondary'
                                                                }
                                                                className="text-white fs-6"
                                                            >
                                                                <FaStethoscope size={12} className="me-1" />
                                                                {modalData.activity_desc}
                                                            </Badge>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <small className="text-muted">Scheduled Date</small>
                                                        <div className="fw-bold">
                                                            <Badge color="secondary" outline className="fs-6">
                                                                <FaCalendarAlt size={12} className="me-1" />
                                                                {modalData.future_activity_date.split(" ")[0].split('-').reverse().join('-')}
                                                            </Badge>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    )}
                </ModalBody>
            </Modal>

            <Footer />
        </>
    );
};

export default LivestockAlert;